// Entrada de la bitacora corta del agente, tal como la devuelve el canal
// en `get_agent_timeline`. Las claves son cortas porque cada entrada se
// guarda serializada en redis.
export interface TimelineEntry {
    // unix epoch en segundos
    t: number;
    // status | dnd | tier | call_in | call_out | registration
    k: string;
    v: string;
    // substatus, solo en dnd
    s?: string;
    // cola, en tier y call_in
    q?: string;
    // numero, en call_in y call_out
    n?: string;
}

export function timelineIconName(entry: TimelineEntry): string {
    switch (entry.k) {
    case 'call_in':
        return 'phone-incoming';
    case 'call_out':
        return 'phone-outgoing';
    case 'registration':
        return 'user';
    default:
        return 'clock';
    }
}

export function timelineIconClass(entry: TimelineEntry): string {
    switch (entry.k) {
    case 'call_in':
    case 'call_out':
        return entry.v === 'ended' ? 'text-gray-400' : 'text-red-500';
    case 'tier':
        return entry.v === 'ready' ? 'text-green-500' : 'text-blue-500';
    case 'registration':
        return entry.v === 'registered' ? 'text-green-500' : 'text-gray-400';
    case 'dnd':
        return entry.v === 'enabled' ? 'text-blue-500' : 'text-green-500';
    default:
        return entry.v === 'unavailable' ? 'text-blue-500' : 'text-gray-500';
    }
}

// del dia se muestra solo la hora, de ayer se agrega el dia porque la
// bitacora llega hasta 24hs atras.
export function timelineTime(unixSeconds: number): string {
    const date = new Date(unixSeconds * 1000);
    const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    if (date.toDateString() === new Date().toDateString()) return time;

    return `${date.getDate()}/${date.getMonth() + 1} ${time}`;
}
